import Alert from "./Alert"

function DarkModeAlert() {
    return (
        <Alert>
            You are on a Samsung device. If you are using your browser in Dark Mode, this page will not display correctly!
        </Alert>
    )
}

export default DarkModeAlert